import { FC } from "react";
import classNames from "classnames";

interface CustomDriverAvatarProps {
  text: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const CustomDriverAvatar: FC<CustomDriverAvatarProps> = ({
  text,
  size = 32,
  className,
  onClick,
}) => {
  // Take only the first 4 characters and convert to uppercase
  const displayText = text.slice(0, 4).toUpperCase();

  const avatarClasses = classNames(
    "rounded-full",
    "bg-black",
    "dark:bg-gray-700",
    "text-white",
    "flex",
    "items-center",
    "justify-center",
    "font-medium",
    "select-none",
    {
      "cursor-pointer": onClick,
      "text-xs": size <= 32,
      "text-sm": size > 32 && size <= 48,
      "text-base": size > 48,
    },
    className
  );

  const sizeStyle = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize:
      size <= 24 ? "10px" : size <= 32 ? "12px" : size <= 48 ? "14px" : "16px",
  };

  return (
    <div
      className={avatarClasses}
      style={sizeStyle}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {displayText}
    </div>
  );
};

export { CustomDriverAvatar };
